<ng-container *ngIf="tags.length">
  <span class="tags-label">{{ rotulo }}</span>

  <span class="tag-filtro" *ngFor="let tag of tags">
    {{ tag.label }}
    <button
      type="button"
      class="btn-remover-tag"
      title="Remover filtro"
      (click)="remover.emit(tag)"
    >
      &times;
    </button>
  </span>

  <button
    *ngIf="exibirLimpar"
    type="button"
    class="btn-limpar-filtros"
    (click)="limpar.emit()"
  >
    <mat-icon>filter_alt_off</mat-icon>
    {{ rotuloLimpar }}
  </button>
</ng-container>
